export enum SearchQueryFormatTypes {
  V1 = 'v1',
  V2 = 'v2',
}
